import React from 'react';
import { FileX } from 'lucide-react';

interface Props {
    message: string;
}

export default function NotFound({ message }: Props) {
    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-900 dark:to-slate-800 flex items-center justify-center p-6">
            <div className="text-center">
                <div className="inline-flex items-center justify-center w-20 h-20 bg-red-100 dark:bg-red-900/20 rounded-full mb-6">
                    <FileX className="h-10 w-10 text-red-600 dark:text-red-400" />
                </div>
                <h1 className="text-3xl font-bold mb-2">File Not Found</h1>
                <p className="text-muted-foreground max-w-md mx-auto">
                    {message}
                </p>
            </div>
        </div>
    );
}